import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import InContentAd from 'ads/InContentAd';
import BannerAd from 'ads/BannerAd';
import { initAdsConfig } from 'ads/actions';
import { setPageInfo } from 'page/actions';
import injectIntl, { intlShape } from 'common/injectIntl';
import { userLocationSelector, userAuthSelector } from 'selectors/authenticationSelectors';
import { fetchSchedule, fetchCategories, setStatusFilter } from 'schedule/actions';
import SectionHeader from 'schedule/SectionHeader';
import FilterGroupContainer from 'schedule/FilterGroupContainer';
import ScheduleCategoryContainer from 'schedule/ScheduleCategoryContainer';
import MainContainer from './common/MainContainer';

const Schedule = (props) => {
    const {
        categories,
        channels,
        isMobile,
        location,
        listings,
        loading,
        mq,
        selectedTab,
        userAuth,
        userLocation,
        messages,
        intl: { formatMessage }
    } = props;
    const bannerAd = [<BannerAd key="banner_ad" />];
    const tabClassname = classNames('watch-tab', { loading });
    return (
        <MainContainer pre={bannerAd}>
            <section className="layout-bc layout-bc--watch">
                <section className="col-b">
                    <article className="watch-schedule">
                        <SectionHeader
                            key="section_header"
                            title={formatMessage(messages['schedule.header'])}
                            mq={mq}
                            isMobile={isMobile}
                        />
                        <FilterGroupContainer
                            channels={channels}
                            categories={categories}
                            location={location}
                        />
                        <div className="content">
                            <div id="tabLive" className={tabClassname} style={{ display: 'block' }}>
                                <ScheduleCategoryContainer
                                    listings={listings}
                                    userAuth={userAuth}
                                    selectedTab={selectedTab}
                                    isMobile={isMobile}
                                    userLocation={userLocation}
                                    startDateValue={location.query.startDate}
                                />
                            </div>
                        </div>
                    </article>
                    <InContentAd include={['s']} adClassName="ad-slot-incontent2" refreshWhenVisible />
                </section>

                <section className="col-c">
                    <InContentAd exclude={['s', 'm']} />
                </section>
            </section>
        </MainContainer>
    );
};

Schedule.propTypes = {
    categories: React.PropTypes.array,
    channels: React.PropTypes.array,
    isMobile: React.PropTypes.bool,
    listings: React.PropTypes.array,
    location: React.PropTypes.object,
    loading: React.PropTypes.bool,
    mq: React.PropTypes.string,
    selectedTab: React.PropTypes.oneOf(['live', 'upcoming', 'replay']),
    userAuth: React.PropTypes.array,
    userLocation: React.PropTypes.object,
    intl: intlShape.isRequired,
    messages: React.PropTypes.object.isRequired
};

Schedule.defaultProps = {
    selectedTab: 'live',
    isMobile: false
};

Schedule.loadActions = [
    () => fetchCategories(),
    (params, { type = 'live' }) => setStatusFilter(type),
    (params, { type = 'live', categoryId, channel, startDate, endDate }) =>
        fetchSchedule({ type, categoryId, channel, startDate, endDate }),
    (params, query) => initAdsConfig('schedule', null, query),
    () => setPageInfo('schedule', 'Schedule')
];


const mapStateToProps = (state) => {
    const { app, schedule } = state;
    return {
        categories: schedule.categories || [],
        channels: schedule.channels || [],
        listings: schedule.listings || [],
        userAuth: userAuthSelector(state),
        userLocation: userLocationSelector(state),
        loading: schedule.loading,
        mq: app.mq,
        selectedTab: schedule.statusFilterValue,
        isMobile: app.isMobile
    };
};

export default connect(mapStateToProps)(injectIntl(Schedule));



// WEBPACK FOOTER //
// ./app/page/Schedule.js